
import React from 'react';
import Button from '../../../components/base/Button';

const ContactSection: React.FC = () => {
  const openZalo = () => {
    window.open('https://zalo.me/0961686191', '_blank');
  };

  const openFacebook = () => {
    window.open('https://www.facebook.com/share/19vdgp3Ku4/?mibextid=wwXIfr', '_blank');
  };

  const callHotline = () => {
    window.open('tel:0961686191', '_self');
  };

  return (
    <section id="contact" className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Liên Hệ &amp; Thông Tin
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Cửa hàng &amp; Xưởng Giặt Ủi Minh Khôi – Đà Lạt
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            {/* Thông tin liên hệ */}
            <div className="bg-white rounded-2xl p-8 shadow-lg">
              <h3 className="text-2xl font-bold text-gray-900 mb-6">
                <i className="ri-contacts-line mr-2 text-teal-600"></i>
                Thông tin liên hệ
              </h3>
              
              <div className="space-y-6">
                <div className="flex items-start">
                  <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mr-4 mt-1">
                    <i className="ri-phone-line text-blue-600 text-xl"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-1">Hotline/Zalo</h4>
                    <p className="text-blue-600 text-lg font-semibold">0961 686 191</p>
                    <p className="text-gray-600 text-sm">Hỗ trợ 24/7, tư vấn miễn phí</p>
                  </div>
                </div>

                <div className="flex items-start">
                  <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center mr-4 mt-1">
                    <i className="ri-time-line text-green-600 text-xl"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-1">Giờ làm việc</h4>
                    <p className="text-gray-700">7h00 – 21h00</p>
                    <p className="text-gray-600 text-sm">Thứ 2 – Chủ nhật (cả ngày lễ)</p>
                  </div>
                </div>

                <div className="flex items-start">
                  <div className="w-12 h-12 bg-purple-100 rounded-full flex items-center justify-center mr-4 mt-1">
                    <i className="ri-map-pin-line text-purple-600 text-xl"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-1">Địa chỉ</h4>
                    <p className="text-gray-700">146 Phù Đổng Thiên Vương, phường Lâm Viên - Đà Lạt, Lâm Đồng</p>
                    <p className="text-gray-600 text-sm">Giao nhận tận nơi toàn thành phố</p>
                  </div>
                </div>

                <div className="flex items-start">
                  <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mr-4 mt-1">
                    <i className="ri-facebook-line text-blue-600 text-xl"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-1">Facebook</h4>
                    <p className="text-blue-600">Giặt Ủi Minh Khôi Đà Lạt</p>
                    <p className="text-gray-600 text-sm">Theo dõi khuyến mãi mới nhất</p>
                  </div>
                </div>
              </div>

              <div className="mt-8 pt-6 border-t border-gray-200">
                <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
                  <Button 
                    variant="primary" 
                    size="sm"
                    onClick={callHotline}
                    className="w-full"
                  >
                    <i className="ri-phone-line mr-2"></i>
                    Gọi ngay
                  </Button>
                  
                  <Button 
                    variant="outline" 
                    size="sm"
                    onClick={openZalo}
                    className="w-full text-green-600 border-green-600 hover:bg-green-50"
                  >
                    <i className="ri-message-3-line mr-2"></i>
                    Chat Zalo
                  </Button>
                  
                  <Button 
                    variant="outline" 
                    size="sm"
                    onClick={openFacebook}
                    className="w-full text-blue-600 border-blue-600 hover:bg-blue-50"
                  >
                    <i className="ri-facebook-line mr-2"></i>
                    Facebook
                  </Button>
                </div>
              </div>
            </div>

            {/* Bản đồ và thông tin bổ sung */}
            <div className="space-y-6">
              <div className="bg-white rounded-2xl p-8 shadow-lg">
                <h3 className="text-2xl font-bold text-gray-900 mb-6">
                  <i className="ri-map-line mr-2 text-green-600"></i>
                  Vị trí cửa hàng
                </h3>
                
                <div className="bg-gray-100 rounded-xl h-64 flex items-center justify-center mb-6">
                  <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3903.3!2d108.4!3d11.9!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMTHCsDU0JzAwLjAiTiAxMDjCsDI0JzAwLjAiRQ!5e0!3m2!1svi!2s!4v1234567890"
                    width="100%"
                    height="100%"
                    style={{ border: 0, borderRadius: '0.75rem' }}
                    allowFullScreen
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                    title="Vị trí Giặt Ủi Minh Khôi"
                  ></iframe>
                </div>
                
                <p className="text-gray-600 text-center">
                  Nhấn vào bản đồ để xem đường đi chi tiết
                </p>
              </div>

              <div className="bg-gradient-to-r from-teal-500 to-blue-500 rounded-2xl p-6 text-white">
                <h4 className="text-xl font-bold mb-4">
                  <i className="ri-customer-service-line mr-2"></i>
                  Cam kết dịch vụ chuyên nghiệp
                </h4>
                <div className="space-y-3">
                  <div className="flex items-center">
                    <i className="ri-check-line mr-3 text-green-300"></i>
                    <span>Phản hồi trong 30 phút</span>
                  </div>
                  <div className="flex items-center">
                    <i className="ri-check-line mr-3 text-green-300"></i>
                    <span>Ủi thẳng bằng máy ủi STAHL Đức</span>
                  </div>
                  <div className="flex items-center">
                    <i className="ri-check-line mr-3 text-green-300"></i>
                    <span>Express 3h siêu nhanh</span>
                  </div>
                  <div className="flex items-center">
                    <i className="ri-check-line mr-3 text-green-300"></i>
                    <span>Chất lượng uy tín - Giá cả cạnh tranh</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
